import {
  Box,
  FormControl,
  Input,
  Heading,
  Text,
  Button,
  Link,
  useToast,
  Flex,
  FormErrorMessage
} from '@chakra-ui/react';
import { useForm } from "react-hook-form";
import { register as registerUser } from "./services/api";
import { useState, useRef, useEffect } from "react";
import "./App.css";

function App() {
  const { register, handleSubmit, watch, formState: { errors } } = useForm({
    mode: "onChange"
  });
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [isSuccess, setIsSuccess] = useState(false);
  const [turnstileToken, setTurnstileToken] = useState(null);
  const turnstileRef = useRef(null);
  const turnstileInitialized = useRef(false);
  const toast = useToast();

  useEffect(() => {
    // Если уже инициализировали, не делаем этого снова
    if (turnstileInitialized.current) return;

    // Создаем функцию для инициализации Turnstile
    const initTurnstile = () => {
      if (typeof window.turnstile !== 'undefined' && !turnstileInitialized.current) {
        turnstileInitialized.current = true;
        turnstileRef.current = window.turnstile.render('#turnstile-widget', {
          sitekey: '0x4AAAAAABfcukYvspltQAp0',
          theme: 'light',
          size: 'normal',
          callback: function (token) {
            setTurnstileToken(token);
          }
        });
      }
    };

    // Если скрипт уже загружен
    if (typeof window.turnstile !== 'undefined') {
      initTurnstile();
    } else {
      // Если скрипт еще не загружен, ждем его загрузки
      window.onloadTurnstileCallback = initTurnstile;
    }

    // Очистка при размонтировании
    return () => {
      if (turnstileRef.current && typeof window.turnstile !== 'undefined') {
        window.turnstile.remove(turnstileRef.current);
        turnstileInitialized.current = false;
      }
    };
  }, []);

  // Следим за значениями полей
  const watchFields = watch(['email', 'username']);
  const isFormValid = watchFields[0] && watchFields[0].trim() !== '' &&
    watchFields[1] && watchFields[1].trim() !== '' && turnstileToken;

  const onSubmit = async (data) => {
    if (!turnstileToken) {
      setErrorMessage("Пожалуйста, подтвердите, что вы не робот");
      return;
    }

    try {
      setIsLoading(true);
      setErrorMessage(null);

      const response = await registerUser({
        ...data,
        turnstileToken
      });

      if (response.error) {
        throw new Error(response.error);
      }

      setIsSuccess(true);
      toast({
        title: "Регистрация успешна. Данные отправлены на email.",
        status: 'success',
        duration: 3000,
        isClosable: true,
      });

    } catch (e) {
      setErrorMessage(e.message);
      toast({
        title: e.message,
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
      // Сбрасываем капчу при ошибке
      if (window.turnstile) {
        window.turnstile.reset('#turnstile-widget');
      }
      setTurnstileToken(null);
    } finally {
      setIsLoading(false);
    }
  };

  if (isSuccess) {
    return (
      <Box
        id="__next"
        bgImage="url('https://needlmusic.ru/images/backgraund.png')"
        bgSize="cover"
        bgRepeat="no-repeat"
        bgPosition="center"
        minH="100vh"
        w="100%"
      >
        <Box className="chakra-container css-1y4iej5">
          <Box style={{ paddingTop: '6rem' }} className="css-1tzelrr">
            <Box>
              <Box className="css-1cvz7qf">
                <Box className="css-11ve6vv">
                  <Box
                    className="css-gmuwbf"
                    style={{ display: 'flex', paddingLeft: '-100px', marginBottom: '20px' }}
                  >
                    <img
                      alt="Either"
                      src="https://auth.needlmusic.ru/static/images/logo.png"
                      decoding="async"
                      style={{
                        display: 'inline-block',
                        verticalAlign: 'middle',
                        marginLeft: '-60px',
                      }}
                      width="110px"
                    />
                    <Heading
                      as="h2"
                      size="md"
                      className="chakra-heading css-1rs9xau"
                      style={{
                        display: 'inline-block',
                        marginLeft: '20px',
                        marginRight: '-60px',
                        userSelect: 'none',
                      }}
                    >
                      NeedIMusic
                    </Heading>
                  </Box>
                  <Flex direction="column" align="center" justify="center" p={8}>
                    <Heading
                      sx={{
                        fontSize: "20px !important", // Жёсткое переопределение
                        lineHeight: "1.2",
                        fontWeight: "bold",
                      }}
                      mb={20}
                    >
                      Регистрация успешна!
                    </Heading>
                    <Text fontSize="md" textAlign="center" mb={8}>
                      Данные были отправлены на вашу электронную почту.<br />
                      При возникноверии каких либо проблем просьба обратиться <Link href='https://vk.me/needlmusic' target='_blank' color='#40b0bf'>в поддержку</Link>.
                    </Text>
                    <Button
                      as="a"
                      href="https://lk.needlmusic.ru"
                      className="chakra-button css-1nkogw7"
                      bg="teal.400"
                      color="white"
                      _hover={{ bg: 'teal.500' }}
                      size="lg"
                      width={{ base: "100%", sm: "400px" }}
                      height="70px"
                      fontSize="20px"
                      mt={20}
                      mb={-50}
                    >
                      Войти в личный кабинет
                    </Button>
                  </Flex>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    );
  }

  return (
    <Box
      id="__next"
      bgImage="url('https://needlmusic.ru/images/backgraund.png')"
      bgSize="cover"
      bgRepeat="no-repeat"
      bgPosition="center"
      minH="100vh"
      w="100%"
    >
      <Box className="css-1t8wt1z"></Box>
      <Box className="chakra-container css-1y4iej5">
        <Box style={{ paddingTop: '6rem' }} className="css-1tzelrr">
          <Box>
            <Box className="css-1cvz7qf">
              <Box className="css-11ve6vv">
                <Box
                  className="css-gmuwbf"
                  style={{ display: 'flex', paddingLeft: '-100px', marginBottom: '20px' }}
                >
                  <img
                    alt="Either"
                    src="https://auth.needlmusic.ru/static/images/logo.png"
                    decoding="async"
                    style={{
                      display: 'inline-block',
                      verticalAlign: 'middle',
                      marginLeft: '-60px',
                    }}
                    width="110px"
                  />
                  <Heading
                    as="h2"
                    size="md"
                    className="chakra-heading css-1rs9xau"
                    style={{
                      display: 'inline-block',
                      marginLeft: '20px',
                      marginRight: '-60px',
                      userSelect: 'none',
                    }}
                  >
                    NeedIMusic
                  </Heading>
                </Box>

                {errorMessage && (
                  <Box className="alert-box" style={{ marginBottom: '-10px' }}>
                    <Text className="alert" textAlign='center' fontWeight="bold" fontSize="18px" mb="-15px">
                      {errorMessage}
                    </Text>
                  </Box>
                )}

                <form onSubmit={handleSubmit(onSubmit)}>
                  <FormControl mb={4} className="css-xd3ife" isInvalid={errors.email}>
                    <Input
                      className="chakra-input css-gygqaw"
                      type="email"
                      placeholder="Электронная почта"
                      {...register("email", {
                        required: "Email обязателен для заполнения",
                        pattern: {
                          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                          message: "Неверный формат email"
                        }
                      })}
                    />
                    <FormErrorMessage>
                      {errors.email && errors.email.message}
                    </FormErrorMessage>
                  </FormControl>
                  <FormControl mb={4} mt="-40px" className="css-xd3ife" isInvalid={errors.username}>
                    <Input
                      className="chakra-input css-gygqaw"
                      type="text"
                      placeholder="Имя профиля"
                      {...register("username", {
                        required: "Псевдоним обязателен для заполнения",
                        pattern: {
                          value: /^[a-zA-Zа-яА-Я0-9_]{3,30}$/,
                          message: "От 3 до 30 символов, цифры и знак подчеркивания"
                        }
                      })}
                    />
                    <FormErrorMessage>
                      {errors.username && errors.username.message}
                    </FormErrorMessage>
                  </FormControl>

                  <Box className="css-xd3ife " mt="-40px" mb={4}>
                    <Flex justify="center" width="100%">
                      <Box
                        width={{ base: "100%", sm: "400px" }}
                        //bg="#fafafa"
                        //className='css-gygqaw'
                        //borderRadius="lg"
                        //border="1px solid"
                        //borderColor="#e0e0e0"
                        p={1}
                        sx={{
                          '#turnstile-widget': {
                            width: '100%',
                            display: 'flex',
                            justifyContent: 'center',
                            '& iframe': {
                              width: '100% !important',
                              maxWidth: 'none !important'
                            }
                          }
                        }}
                      >
                        <div id="turnstile-widget"></div>
                      </Box>
                    </Flex>
                  </Box>

                  <Box className="css-xd3ife" mt="-30px">
                    <Button
                      type="submit"
                      className="chakra-button css-1nkogw7"
                      bg={isFormValid ? "teal.400" : "gray.400"}
                      color="white"
                      _hover={{ bg: isFormValid ? 'teal.500' : 'gray.500' }}
                      isLoading={isLoading}
                      disabled={!isFormValid || isLoading}
                    >
                      Зарегистрироваться
                    </Button>
                  </Box>
                </form>

                <Box userSelect="none" className="css-xd3ife" mt="-40px">
                  <Flex justifyContent="center" alignItems="center">
                    <Text textAlign="center" style={{ color: "gray" }}>
                      Нажимая на кнопку вы соглашаетесь с<br />
                      <Link href="https://needlmusic.ru/privacy" textDecoration="underline" isExternal>
                        Политикой конфиденциальности
                      </Link> и <Link href="https://needlmusic.ru/terms" textDecoration="underline" isExternal>
                        Публичной офертой
                      </Link>
                    </Text>
                  </Flex>
                </Box>

                <Box mt={10} mb='-40px' userSelect="none">
                  <Flex justifyContent="center" alignItems="center">
                    <Text>Уже есть аккаунт?&nbsp;&nbsp;</Text>
                    <Link href="https://lk.needlmusic.ru" color="teal.400" style={{ color: "teal" }}>
                      Войти
                    </Link>
                  </Flex>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default App;